module.exports = __webpack_public_path__ + "static/top-0bd0c0c4f3cdf97168daf6697f0c8e12.png";